module.exports = __webpack_public_path__ + "img/logo.fc04d0b1.png";